import http from "@/plugins/axios";

export default {
    getSymbolList(data) {
        return http.get({
            url: '/la/admin/tenant/contractSymbol/contractSymbolList',
            data
        })
    },

    getSpotSymbolPage(data) {
        return http.get({
            url: `/la/admin/tenant/spotSymbol/getSpotSymbolPage`,
            data
        });
    },
    updateContractSymbol(data) {
        return http.post({
            url: `/la/admin/tenant/contractSymbol/updateContractSymbol`,
            data
        })
    },


    getContractSymbolPage(data) {
        return http.get({
            url: `/la/admin/tenant/contractSymbol/getContractSymbolPage`,
            data
        });
    },
};
